var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteiconsSvg14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2822_1546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2822_1546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26276 3.26278H46.7373V46.7373H3.26276V3.26278Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2822_1546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7929 24.9151C31.7929 22.4023 30.4249 20.2134 28.3964 19.0384L27.5473 24.9151H22.4527L21.6035 19.0384C19.5751 20.2134 18.2071 22.4023 18.2071 24.9151C18.2071 27.5993 19.768 29.9132 22.0281 31.0163V45.4636H27.9719V31.0163C30.232 29.9132 31.7929 27.5993 31.7929 24.9151Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3787 28.3116V21.5187L41.4415 20.7313C41.0358 19.1333 40.4072 17.6285 39.5845 16.2474L41.8116 12.9069L37.0083 8.10357L33.6677 10.3306C32.2866 9.50801 30.7819 8.87941 29.1839 8.4737L28.3965 4.53645H21.6036L20.8162 8.4737C19.2182 8.87941 17.7135 9.50801 16.3324 10.3306L12.9917 8.10357L8.18846 12.9069L10.4155 16.2474C9.59289 17.6285 8.9642 19.1333 8.55858 20.7313L4.62134 21.5187V28.3116L8.55858 29.099C8.9642 30.697 9.59289 32.2017 10.4155 33.5828L8.18846 36.9234L12.9917 41.7266L16.3324 39.4997V33.0348C14.3377 30.9116 13.1125 28.059 13.1125 24.9151C13.1125 18.3498 18.4347 13.0276 25 13.0276C31.5654 13.0276 36.8876 18.3498 36.8876 24.9151C36.8876 28.059 35.6623 30.9116 33.6677 33.0348V39.4997L37.0083 41.7266L41.8116 36.9234L39.5845 33.5828C40.4072 32.2017 41.0358 30.697 41.4415 29.099L45.3787 28.3116Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2822_1546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.4745,
    height: 43.4745,
    fill: "white",
    transform: "translate(3.26276 3.26276)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteiconsSvg14);
export default __webpack_public_path__ + "static/media/Website icons SVG-14.6ddaabf34c990ad2a29c6776f60541ee.svg";
export { ForwardRef as ReactComponent };